import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@sezane/front-components';
import translate from '../../../../translate';
const LastMinuteShoppingButton = ({ className, tracking, ...props }) => (_jsx(Button, { className: `js-add-cart-button${className ? ` ${className}` : ''}`, fullWidth: true, "data-cart-add-product": true, "data-tracking": `${JSON.stringify(tracking)}`, "data-last-minute": "true", ...props, children: translate('front.product.index.paris_fast_delivery') }));
export default LastMinuteShoppingButton;
